/**
 * 密码加密公钥
 */
export const PUBLIC_KEY =
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkg+3iDWtBDkWfeU9AWy/uhocsknjchT+Qjj1EVfoX+fIQ1o8mzXUm4ah9xfT4vuWkAzyy241+XWmAaLrz0IiKDKgy9MwAIlQN9pHYc9Zny330sEmAh9rWCFFzGY9og4Ou40ITCYvvQAmC1wpNEhp2NLtS8nqOxD/AF0oMUNOLBF4hlJ0ftjN9bp7l5RU5NM6BZ+XS5PsGUDwFFM2gojZoKC/pwDzmY47s4MUZ+1TV2T0uGPF+oQOHIEjQ4CMcrKb9olr6M9/evPaAJOOC84ZwpPd6ZRMyXXbQZm1bGpGvj+0VyTxxJS8D+d+PAlCIY8oAZzugLSwZweVou7WZ1OnlwIDAQAB";
